import classes from "../../pages/CreateQuizPage/ActivityEditor.module.css";
import EntriesInputBox from "../../components/EntriesInputBox";
import React from "react";
import {updateEntries} from "../../utils/questionUpdate";

export default function WCQuestion({
                                       setQuestions,
                                       questions,
                                       selectedQuestion,
                                   }) {
    const {entries, serialNo} = selectedQuestion;
    const handleEntriesUpdate = (v) => {
        if (!v) {
            v = 0;
        } else {
            v = parseInt(v);
        }
        setQuestions(updateEntries(v, serialNo - 1, questions));
    };

    return (
        <div style={{display: "flex", width: "100%", alignItems: "center", gap: 10, justifyContent: "flex-end"}}>
            <span className={classes.title}>Entries</span>
            <EntriesInputBox
                containerStyle={{padding: 2}}
                style={{textAlign: "center", width: 50}}
                value={`${entries}`}
                onBlur={handleEntriesUpdate}
            />

        </div>
    );
}